import { t } from '../i18n';
import type { MenuSummary } from '../lib/api';

/** "https://www.example.co/menu.pdf" → "example.co/menu.pdf" */
export function menuLabel(menu: Pick<MenuSummary, 'url'>): string {
  return menu.url?.replace(/^https?:\/\/(www\.)?/i, '').replace(/\/$/, '') ?? t('menus.noUrl');
}
